import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router/index.js'
import MainView from './views/MainView'

import Vuetify, {
  VApp,
  VAppBar,
  VMain,
  VIcon,
  VBtn,
  VContainer,
  VLayout,
  VFlex,
  VSpacer,
  VForm,
  VProgressCircular,
  VSnackbar,
  VRadio,
  VTextField,
  VExpansionPanel,
  VDivider
} from 'vuetify/lib'
import { Ripple } from 'vuetify/es5/directives'
import 'vuetify/dist/vuetify.min.css'

import VueResource from 'vue-resource'

import en from 'vuetify/es5/locale/en'
import es from 'vuetify/es5/locale/es'
import { i18n } from './locale'


Vue.config.productionTip = false

const locale = (navigator.language || navigator.userLanguage).split('-')[0] === 'es' ? 'es' : 'en'

const vuetifyOpts = {
  lang: {
    locales: { en, es },
    current: locale
  },
  locale,
  theme: {
    themes: {
      light: {
        primary: '#342ebf',
        secondary: '#f4f9fb',
        tertiary: '#e4edf1',
        quaternary: '#cfdde3',
        accent: '#fc3579',
        error: '#D32F2F'
      }
    }
  }
}

Vue.use(Vuetify, {
  components: {
    VApp,
    VAppBar,
    VMain,
    VIcon,
    VBtn,
    VContainer,
    VLayout,
    VFlex,
    VSpacer,
    VForm,
    VProgressCircular,
    VSnackbar,
    VRadio,
    VTextField,
    VExpansionPanel,
    VDivider,
    MainView
  },
  directives: {
    Ripple
  }
})

Vue.use(VueResource)

new Vue({
  vuetify: new Vuetify(vuetifyOpts),
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
